import { createContext, useContext } from 'react';

const LibraryContext = createContext(null);
export const LibraryProvider = LibraryContext.Provider;
export function useLibraryContext() {
  const context = useContext(LibraryContext);
  return context;
}
